// ITAM-2887: the landing route, extracted so it has exactly one definition.

export interface DefaultRouteInput {
  isPharmacist: boolean;
  isAdvisor: boolean;
  isAssociation?: boolean;
}

export const resolveDefaultRoute = ({
  isPharmacist,
  isAdvisor,
  isAssociation = false,
}: DefaultRouteInput): string => {
  // A portal session (association, advisor) can never also be a staff
  // session (the staff roles suppress both capabilities), so these branches
  // cannot steal another persona's landing route.
  if (isAssociation) return "/association";
  if (isAdvisor) return "/advisor-profile";
  return isPharmacist ? "/pharmacist-support" : "/order-processing";
};
